import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import { NumericFormat } from 'react-number-format';

const StyledInput = styled(TextField)(({ theme }) => ({
  borderColor: theme.palette.gray[200],
  '& .MuiOutlinedInput-root': {
    alignItems: 'stretch',
    paddingRight: 0,
    borderRadius: 6,
    borderColor: theme.palette.gray[100],
    '&:hover': {
      '.MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.gray[200],
      },
    },
    '&.Mui-focused': {
      '.MuiOutlinedInput-notchedOutline': {
        borderColor: `${theme.palette.primary.main} !important`,
      },
    },
    '& fieldset': {
      borderColor: theme.palette.gray[200],
    },
  },
  '& .MuiInputAdornment-root': {
    paddingLeft: 18,
    paddingRight: 18,
    borderTopRightRadius: 6,
    borderBottomRightRadius: 6,
    textAlign: 'center',
    height: 'auto',
    maxHeight: '100%',
    backgroundColor: theme.palette.gray[50],
    '&:focus': {
      borderColor: theme.palette.primary.main,
    },
  },
}));

type PercentageInputProps = React.ComponentProps<typeof NumericFormat> &
  React.ComponentProps<typeof StyledInput> & {
    isInvalid?: boolean;
    isReadOnly?: boolean;
    isDisabled?: boolean;
  };

export default function PercentageInput({
  isInvalid,
  isReadOnly,
  isDisabled,
  ...props
}: Readonly<PercentageInputProps>) {
  return (
    <NumericFormat<React.ComponentProps<typeof StyledInput>>
      customInput={StyledInput}
      disabled={isDisabled || isReadOnly}
      error={isInvalid}
      InputProps={{
        endAdornment: <InputAdornment position="end">%</InputAdornment>,
      }}
      size="small"
      decimalScale={2}
      fixedDecimalScale
      isAllowed={({ floatValue }) =>
        floatValue === undefined || (floatValue >= 0 && floatValue <= 100)
      }
      {...props}
    />
  );
}
